import axios from "axios";
import stationUtils from "../../stationUtils";

export default {
  name: "InitialPreferences",
  mixins: [stationUtils],
  data: function () {
    return {
      showDeclare: false,
      showWarehouses: false,
      declareStationEnabled: false,
      showDialog: false,
      declareStationIsShown: false,

      meterWarehouses: [],
      warehouses: [],
      meterWarehouse: null,
      warehouse: null,
      //meterWarehouseId: null,
      //warehouseId: null,
      linkToWarehouse: null,

      preference: {},

      assignedStationId: -1,
    };
  },
  created() {
    this.getProfileDetails();
    //console.log("dlkjslkdfjlk")
  },
  methods: {
    getProfileDetails() {
      console.log("getProfileDetails");
      axios
        .post("/account/GetProfileDetails")
        .then(async (response) => {
          if (response.data.data.status == 0) {
            this.linkToWarehouse = true; //response.data.item.linkToWarehouse;

            this.assignedStationId = response.data.item.employeeStationId;

            let preferenceData = this.$localStorage.get("_preference");
            this.preference = preferenceData
              ? JSON.parse(preferenceData)
              : null;

            if (this.linkToWarehouse == true) {
              this.showWarehouses = true;
              this.showDialog = true;
            } else {
              this.showWarehouses = false;
              this.showDialog = false;
            }

            let stations = this.$store.getters.getUserStations;
            if (!stations || stations.declared.id < 0)
              this.declareStationEnabled = response.data.item.declaredStation;
            else this.declareStationEnabled = false;

            if (this.declareStationEnabled) {
              await this.getStations();
              if (!(!this.empStations || this.empStations.length == 0))
                this.showDialog = true;
            }

            if (this.showWarehouses) {
              this.getMeterWarehouses(response.data.item.meterWarehouseId);
              this.getWarehouses(response.data.item.warehouseId);
              if (
                !(
                  !this.meterWarehouses ||
                  this.meterWarehouses.length == 0 ||
                  !this.warehouses ||
                  this.warehouses.length == 0
                )
              )
                this.showDialog = true;
            }
          } else {
            this.$router.push("/login");
          }
        })
        .catch((e) => {
          this.$router.push("/login");
        });
    },
    async getWarehouses(selectedWarehouseId) {
      return await axios
        .post("/Om/GetWarehouses", { Value: -1 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.warehouses = response.data.items;
            this.warehouse = this.warehouses.filter(
              (w) => w.id == selectedWarehouseId
            )[0];
            return true;
          } else {
            this.$oldAlertMsg(response.data.data.text, 4);
            return false;
          }
        })
        .catch((error) => {
          this.$oldAlertMsg(error, 4);
          return false;
        });
    },
    async getMeterWarehouses(selectedWarehouseId) {
      return await axios
        .post("/Account/GetMeterWarehouses")
        .then((response) => {
          if (response.data.data.status == 0) {
            this.meterWarehouses = response.data.items;
            this.meterWarehouse = this.meterWarehouses.filter(
              (w) => w.id == selectedWarehouseId
            )[0];
            return true;
          } else {
            this.$oldAlertMsg(response.data.data.text, 4);
            return false;
          }
        })
        .catch((error) => {
          this.$oldAlertMsg(error, 4);
          return false;
        });
    },

    async actions() {
      if (this.declareStationEnabled) {
        this.saveStations(this.stationDeclared);
      }

      if (this.showWarehouses) {
        if ((await this.savePreference()) == false) return;
      }

      this.showDialog = false;
    },
    async savePreference() {
      this.preference.preferenced = true;
      this.preference.linkToWarehouse = this.linkToWarehouse;
      this.preference.warehouseId = this.warehouse.id;
      this.preference.meterWarehouseId = this.meterWarehouse.id;

      this.$localStorage.set("_preference", JSON.stringify(this.preference));

      return await axios
        .post("/Account/SetProfileWarehouse", {
          WarehouseId: this.preference.warehouseId,
          MeterWarehouseId: this.preference.meterWarehouseId,
        })
        .then((response) => {
          if (response.data.data.status != 0 || response.status != 200) {
            this.$oldAlertMsg(response.data.data.text, 2);
            return false;
          }

          return true;
        })
        .catch((e) => {
          this.$oldAlertMsg(e.message, 4);
          return false;
        });
    },
  },
};
